// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"tn-z","badgeLink":"un-z","category":"vn-z"};